export default {
  'reportsSettings.sales.title': 'Reports Settings',
  'reportsSettings.sales.section.salesReport': 'Earning & Payout Report',
  'reportsSettings.sales.excludeDeferredSalesFromReceivable':
    'Do not include the “Deferred Sales” (i.e., Gift Card , Prepaid Loyalty) in the “Receivable Amount”',
  'reportsSettings.sales.excludeDeferredSalesFromReceivable.description':
    'Tips: After turning on the switch, the Deferred Sales Amount will be displayed separately and will not be included in the accounts receivable amount in the Dashboard Earning & Payout Report 、Daily Closeout Report and Monthly Statement!',
};
